// removed by extract-text-webpack-plugin
module.exports = {"container":"ScaleBox__container___2ISMI2m","point":"ScaleBox__point___2xGeR8M","pointFocus":"ScaleBox__pointFocus___Qx6RIJb"};